// extracted by mini-css-extract-plugin
export default {"cell":"ShopperGroupIncentive_cell__vKtke","label":"ShopperGroupIncentive_label__gfqDP","value":"ShopperGroupIncentive_value__GPRmj"};